// @group Constants : Current public release shown in What's New surfaces
export const APP_RELEASE_VERSION = '1.11.1';
export const APP_RELEASE_DATE = 'June 2026';
export const APP_RELEASE_SUBTITLE = `EZ PM2 GUI · ${APP_RELEASE_DATE}`;
